import "./CategoryControl.scss";
import { ReactComponent as ArrowDiagonal } from "./../../assets/images/arrow-diagonal.svg";
import { useEffect } from "react";
import { Link } from "wouter";

export function CategoryControl({
	setHoveredCategory,
	activeCategory,
	delay = 0.5,
	duration = 2,
	modalOpen,
}) {
	const handleMouseOver = (e) => {
		const { category } = e.target.dataset;
		setHoveredCategory(category);
	};

	const handleMouseOut = () => {
		setHoveredCategory(activeCategory);
	};

	useEffect(() => {
		setHoveredCategory(activeCategory);
	}, [setHoveredCategory, activeCategory]);

	return (
		<div
			className={`category-control ${
				modalOpen ? "category-control--modal-open" : ""
			}`}
			style={{ "--delay": `${delay}s`, "--duration": `${duration}s` }}>
			<div className="category-control__controls">
				<div className="category-control__buttons">
					<Link href="/tech-radar/category/access">
						<button
							className={`category-control__button category-control__button--access ${
								activeCategory === "access"
									? "category-control__button--active"
									: ""
							}`}
							onMouseOver={handleMouseOver}
							onMouseOut={handleMouseOut}
							data-category="access">
							Access <ArrowDiagonal />
						</button>
					</Link>
					<Link href="/tech-radar/category/immersion">
						<button
							className={`category-control__button category-control__button--immersion ${
								activeCategory === "immersion"
									? "category-control__button--active"
									: ""
							}`}
							onMouseOver={handleMouseOver}
							onMouseOut={handleMouseOut}
							data-category="immersion">
							Immersion <ArrowDiagonal />
						</button>
					</Link>
					<Link href="/tech-radar/category/transaction">
						<button
							className={`category-control__button category-control__button--transaction ${
								activeCategory === "transaction"
									? "category-control__button--active"
									: ""
							}`}
							onMouseOver={handleMouseOver}
							onMouseOut={handleMouseOut}
							data-category="transaction">
							Transaction <ArrowDiagonal />
						</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
